import React from "react";
import {REFERRAL_LINK} from "../../default_informations/referral_link";

function SidebarBanner({banner}) {
    const referral_link = REFERRAL_LINK

    return (
        <div className="gg-slots__item ">
            <figure className="gg-slots__item__inner">
                <div className="gg-slots-h">
                    <img src={banner.img} alt={banner.title} />
                </div>
                <p className="gg-slots-title">{banner.title}</p>
                <a className="btn" href={referral_link} rel="nofollow noopener noreferrer"
                   target="_blank">{banner.link.text}</a>
            </figure>
        </div>
    )
}

export default SidebarBanner;